export default __webpack_public_path__ + "static/media/docIcon.6abb6b97.svg";